var headerJs = (function() {
  function init() {
    //check header habitat Menu html exists
    if (document.getElementById("header-habitat") && document.getElementById("header-habitat").innerHTML.length > 0) {
      uiBindings();
    }
  }

  var uiBindings = function() {
    /**
     * Sticky header Promo Bar
     */
    var promoBar = document.getElementById("promo-notification");
    var headerElem = document.getElementById("header-habitat");

    window.addEventListener('DOMContentLoaded',function () {
      if (promoBar) {
        if (Cookie.read("closePromoNotification") || window.innerWidth <= 979) {  
          promoBar.remove();
        } else {
          promoBar = document.getElementById("promo-notification");
          promoBar.classList.remove("hide");
        } 
      }  
    });

    /**
     * Promo Bar Function for sticky header availble for window width greater than 980px
     */
    if (
      document.body.classList.contains("header-with-promo-bar") &&
      !headerElem.classList.contains("header-habitat--has-secondary-menu")
    ) {
      function promoBarFunc(promoBar, headerElem) {
        if (window.innerWidth < 979) {
          return;
        }
        if (promoBar) {
          var promoBarHeight = promoBar.offsetHeight;
        }
        window.addEventListener(
          "scroll",
          function(e) {
            var headerWithPromo = document.body;
            if (
              Cookie.read("closePromoNotification") &&
              window.innerWidth > 979
            ) {
              headerWithPromo.classList.add("promo-sticky-header");
              headerWithPromo.style.paddingTop = headerElem.offsetHeight + "px";
            } else {
              if (
                window.pageYOffset > promoBarHeight &&
                window.innerWidth > 979
              ) {
                headerWithPromo.classList.add("promo-sticky-header");
                headerWithPromo.style.paddingTop =
                  promoBarHeight + headerElem.offsetHeight + "px";
                promoBar.classList.add("hide");
              } else {
                if (promoBar) {
                  headerWithPromo.classList.remove("promo-sticky-header");
                  promoBar.classList.remove("hide");
                  headerWithPromo.style.paddingTop = "0";
                }
              }
            }
          },
          false
        );
      }

      /**
       * Call function promo bar sticky header
       */
      promoBarFunc(promoBar, headerElem);

      window.addEventListener(
        "resize",
        function() {
          if (window.innerWidth > 979) {
            promoBarFunc(promoBar, headerElem);
          }
        },
        false
      );
    }
    if (promoBar) {
      /**
       * Promo Bar close button event
       */
      var promoClose = document.getElementsByClassName(
        "accept-promo-notification-cross"
      );
      var promoCta = document.querySelectorAll(".promo-notification a:not(.custom-promobar-link)");
      if (promoClose) {
        for (i = 0; i < promoClose.length; i++) {
          promoClose[i].addEventListener("click", removePromoBar);
        }
      }

      if (promoCta) {
        for (i = 0; i < promoCta.length; i++) {
          promoCta[i].addEventListener("click", removePromoBar);
        }
      }
    }

    /**
     * This code is for Product Pages.
     * If secondary nav bar is enabled and when the Promo bar is also enabled
     */

    var secHeader = document.getElementById("secondary-nav");
    if (secHeader) {
      var secNavCta = document.getElementById("sec_nav_cta");
      var secHeaderLogo = document.getElementById("sec-header-logo");
      var secHeaderTitle = document.getElementById("sec-header-title"),
      secSignInLink = document.getElementById("sign_in_link"),
      secFreeTrialCTA = document.getElementById("free-trial-cta"),
      secNavContactSalesBtn = document.getElementById("secNavContactSalesBtn");

      var stickyTop =
        secHeader.offsetTop + (promoBar ? promoBar.offsetHeight : 0);

      window.addEventListener(
        "scroll",
        function(e) {
          if (window.pageYOffset >= stickyTop) {
            if (!secHeader.classList.contains("sticky-header")) {
              secHeader.className += " " + "sticky-header";
            }
            if (!secNavCta.classList.contains("active")) {
              secNavCta.className += " " + "active";
              if (secSignInLink)  { secSignInLink.tabIndex = 0; }
              if (secFreeTrialCTA)  { secFreeTrialCTA.tabIndex = 0; }
              if (secNavContactSalesBtn)  { secNavContactSalesBtn.tabIndex = 0; }
            }
            if (!secHeaderLogo.classList.contains("active")) {
              secHeaderLogo.className += " " + "active";
            }
            if (!secHeaderTitle.classList.contains("show-logo")) {
              secHeaderTitle.className += " " + "show-logo";
            }
          } else {
            secHeader.classList.remove("sticky-header");
            secNavCta.classList.remove("active");
            secHeaderLogo.classList.remove("active");
            secHeaderTitle.classList.remove("show-logo");

            if (secSignInLink)  { secSignInLink.tabIndex = -1; }
            if (secFreeTrialCTA)  { secFreeTrialCTA.tabIndex = -1; }
            if (secNavContactSalesBtn)  { secNavContactSalesBtn.tabIndex = -1; }
          }
        },
        false
      );
    }

    /* Footer Menu Toogle */
    var footerMenuBlock = document.getElementById("footer-menu-toggle");
    var footerMenuIcon = document.getElementById("footer-menu-click");
    
    if (footerMenuIcon) {
      var footerDesktopLinks = footerMenuBlock.querySelectorAll("a");
      for (var j = 0; j < footerDesktopLinks.length; j++) {
        footerDesktopLinks[j].tabIndex = -1;
      }

      footerMenuIcon.addEventListener("click", function(e) {
        e.preventDefault();
        footerMenuBlock.classList.toggle("active");
        if (!footerMenuBlock.classList.contains("active")) {
          footerMenuBlock.classList.remove("active");
        }
        var footerDesktopLinks = footerMenuBlock.querySelectorAll("a");
        for (var j = 0; j < footerDesktopLinks.length; j++) {
          footerDesktopLinks[j].tabIndex = 0;
          if (!footerMenuBlock.classList.contains("active")) {
            footerDesktopLinks[j].tabIndex = -1;
          }
        }
      });
    }

    /* Footer Menu Mobile Toogle */
    var footerMobileMenuBlock = document.getElementById(
      "footer-mobile-menu-toggle"
    );
    var footerMobileMenuIcon = document.getElementById(
      "footer-mobile-menu-click"
    );

    if (footerMobileMenuIcon) {
      var footerMobileLinks = footerMobileMenuBlock.querySelectorAll("a");
      for (var j = 0; j < footerMobileLinks.length; j++) {
        footerMobileLinks[j].tabIndex = -1;
      }
      footerMobileMenuIcon.addEventListener("click", function(e) {
        e.preventDefault();
        footerMobileMenuBlock.classList.toggle("active");
        if (!footerMobileMenuBlock.classList.contains("active")) {
          footerMobileMenuBlock.classList.remove("active");
        }

        var footerMobileLinks = footerMobileMenuBlock.querySelectorAll("a");
        for (var j = 0; j < footerMobileLinks.length; j++) {
          footerMobileLinks[j].tabIndex = 0;
          if (!footerMobileMenuBlock.classList.contains("active")) {
            footerMobileLinks[j].tabIndex = -1;
          }
        }
      });
    }

    /*
     * Persistent header fixed on scroll up and down
     */
    function persistentHeaderForMobile() {
      var body = document.body;
      var headerElem = document.getElementById("header-habitat"),
        promoBar = document.getElementById("promo-notification"),
        secondaryNav = document.getElementById("secondary-nav")
        primaryMenuToggle = document.getElementById("primary-menu-toggle"),
        scrollUp = "persistent-up",
        scrollDown = "persistent-down",
        scrollTop = "persistent-top",
        lastScroll = 0;
      if (window.innerWidth >= 980 && secondaryNav) {
        body.classList.remove("persistent-header");
        return;
      } else if (window.innerWidth >= 980) {
        return;
      } else {
        body.classList.add("persistent-header");
      }
      window.addEventListener("scroll", function() {
        //Check mobile toggle menu enable
        if(primaryMenuToggle) {
          if (primaryMenuToggle.classList.contains("active")) {
            return;
          }
        }
        var currentScroll = window.pageYOffset,
          offsetScroll = promoBar
            ? promoBar.offsetHeight
            : headerElem.offsetHeight,
          offsetHeight =
            headerElem.offsetHeight + (promoBar ? promoBar.offsetHeight : 0);
        if (currentScroll == 0) {
          body.classList.remove(scrollUp);
          body.style.paddingTop = "0";
          lastScroll = 0;
          return;
        }

        if (currentScroll < offsetScroll) {
          if (promoBar) {
            body.classList.remove(scrollUp);
            body.style.paddingTop = "0";
            lastScroll = 0;
          }
          if (!secondaryNav) {
            headerElem.style.top = "0";
          }
          return;
        } else if (
          !body.classList.contains(scrollDown) &&
          !body.classList.contains(scrollUp) &&
          currentScroll > offsetHeight
        ) {
          if (secondaryNav) {
            body.classList.add(scrollTop);
            headerElem.style.top = -headerElem.offsetHeight + "px";
            body.style.paddingTop =
              headerElem.offsetHeight +
              (secondaryNav ? secondaryNav.offsetHeight : 0) +
              "px";
          } else {
            headerElem.style.top = -headerElem.offsetHeight + "px";
          }
        }

        if (
          currentScroll > lastScroll &&
          !body.classList.contains(scrollDown) &&
          body.classList.contains(scrollUp)
        ) {
          // down
          body.classList.remove(scrollTop);
          body.classList.remove(scrollUp);
          body.classList.add(scrollDown);
          body.style.paddingTop =
            headerElem.offsetHeight +
            (secondaryNav ? secondaryNav.offsetHeight : 0) +
            "px";
          headerElem.style.top = -headerElem.offsetHeight + "px";
        } else if (
          currentScroll < lastScroll &&
          !body.classList.contains(scrollUp)
        ) {
          // up
          body.classList.remove(scrollTop);
          body.classList.remove(scrollDown);
          body.classList.add(scrollUp);
          body.style.paddingTop =
            headerElem.offsetHeight +
            (secondaryNav ? secondaryNav.offsetHeight : 0) +
            "px";
          headerElem.style.top = "0";
        }
        lastScroll = currentScroll;
      });
    }

    persistentHeaderForMobile();

    //Resize to call func
    window.addEventListener(
      "resize",
      function() {
        persistentHeaderForMobile();
      },
      false
    );
  };

  function removePromoBar() {
    var promoBar = document.getElementById("promo-notification");
    if (promoBar) {
      promoBar.remove();
      Cookie.create("closePromoNotification", "1", 5);
    }
  }

  return {
    init: init
  };

})();

headerJs.init();